// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as MenuComponent} from './Menu.svg';

import Icon, { TIconProps } from '../Icon';

export const IconMenu = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <MenuComponent/>
  </Icon>
));
